import React, { Fragment, useRef, useState, useEffect } from "react";
import { Btn, H4 } from "../../../../AbstractElements";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import {
  Save,
  EditUserTxt,
  firstnameTxt,
  lastnameTxt,
  emailTxt,
  hireDateTxt,
  StatusMapping,
  userTypeMapping,
  salaryTxt,
  bonusTxt,
  userTypeTxt,
  phoneTxt,
  terminationDateTxt,
  sendEmailTxt,
  DeleteTxt,
} from "../../../../Constant";
import SweetAlert from "sweetalert2";
import { toast } from "react-toastify";
import FsLightbox from "fslightbox-react";
import userimg from "../../../../assets/images/user/user.png";
import DatePicker from "react-datepicker";
import {
  archiveUserProfile,
  findUserByEmployeeID,
  isTerminatedStatus,
  parseUserDate,
  serializeUserDate,
  updateUserProfile,
} from "../userFirebase";
import { createAdminOperationTracker } from "../../../../utils/adminDataMutationClient";
import i18n from "../../../../i18n";

const EditUser = (props) => {
  const employeeID = props.userid;

  const { handleSubmit } = useForm();
  const [imgToggle, setImgToggle] = useState(false);
  const photoInputRef = useRef(null);
  const operationTrackerRef = useRef(null);

  if (!operationTrackerRef.current) {
    operationTrackerRef.current = createAdminOperationTracker();
  }

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [hireDate, setHireDate] = useState("");
  const [salary, setSalary] = useState("");
  const [phone, setPhone] = useState("");
  const [bonus, setBonus] = useState("");
  const [userStatus, setUserStatus] = useState("");
  const [userType, setUserType] = useState("");
  const [endDate, setEndDate] = useState("");
  const [userPhoto, setUserPhoto] = useState("");
  const [userUID, setUserUID] = useState("");
  const [sendPasswordEmail, setSendPasswordEmail] = useState(false);
  const [profileUnavailable, setProfileUnavailable] = useState(false);

  const [editMode, setEditMode] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingCompleted, setLoadingCompleted] = useState(false);

  const [errorFirstName, setErrorFirstName] = useState(false);
  const [errorLastName, setErrorLastName] = useState(false);
  const [errorEmail, setErrorEmail] = useState(false);
  const [errorHireDate, setErrorHireDate] = useState(false);
  const [errorEndDate, setErrorEndDate] = useState(false);
  const [errorSalary, setErrorSalary] = useState(false);
  const [errorPhone, setErrorPhone] = useState(false);
  const [errorUserType, setErrorUserType] = useState(false);
  const [errorForm, setErrorForm] = useState(false);

  const [errorFormMsg, setErrorFormMsg] = useState("");
  const [errorFieldMsg, setErrorFieldMsg] = useState(
    i18n.t('Dashboard_Users_FieldRequired')
  );
  const [errorEmailMsg, setErrorEmailMsg] = useState("");
  const [errorSalaryMsg, setErrorSalaryMsg] = useState("");

  useEffect(() => {
    if (props.userid != "") {
      getUserByID(props.userid);
    }
  }, [props.userid]);

  const profilePhoto = userPhoto || userimg;

  const handlePhotoButtonClick = (event) => {
    event.preventDefault();
    photoInputRef.current?.click();
  };

  const handlePhotoChange = (event) => {
    const file = event.target.files?.[0];

    if (!file) {
      return;
    }

    setErrorForm(false);
    setErrorFormMsg("");

    if (!file.type.startsWith("image/")) {
      setErrorForm(true);
      setErrorFormMsg("Veuillez choisir un fichier image valide.");
      event.target.value = "";
      return;
    }

    if (file.size > 500 * 1024) {
      setErrorForm(true);
      setErrorFormMsg("Veuillez choisir une image de moins de 500 Ko.");
      event.target.value = "";
      return;
    }

    const reader = new FileReader();
    reader.onload = () => setUserPhoto(String(reader.result || ""));
    reader.onerror = () => {
      setErrorForm(true);
      setErrorFormMsg("Impossible de charger l'image selectionnee.");
    };
    reader.readAsDataURL(file);
    event.target.value = "";
  };

  const validateForm = (e) => {
    let isValid = true; // By Default the form is set to be valid.

    if (!firstName) {
      setErrorFirstName(true);
      isValid = false;
    } else {
      setErrorFirstName(false);
    }

    if (!lastName) {
      setErrorLastName(true);
      isValid = false;
    } else {
      setErrorLastName(false);
    }

    if (!phone) {
      setErrorPhone(true);
      isValid = false;
    } else {
      setErrorPhone(false);
    }

    if (!email) {
      setErrorEmail(true);
      setErrorEmailMsg("Veuillez entrer une addresse courriel");
      isValid = false;
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) {
      setErrorEmail(true);
      setErrorEmailMsg(
        "Veuillez entrer une addresse courriel valide par exemple : John.Smith@email.com"
      );
      isValid = false;
    } else {
      setErrorEmail(false);
    }

    if (!hireDate) {
      setErrorHireDate(true);
      isValid = false;
    } else {
      setErrorHireDate(false);
    }

    if (!salary) {
      setErrorSalary(true);
      setErrorSalaryMsg("Veuillez entrer un salaire");
      isValid = false;
    } else if (!/^[0-9]{0,2}(\.[0-9]{2})?$/i.test(salary)) {
      setErrorSalaryMsg("Veuillez entrer un salaire format : 00.00");
      setErrorSalary(true);
      isValid = false;
    }

    return isValid;
  };

  const onEditSubmit = (data) => {
    if (profileUnavailable || !userUID) {
      setErrorForm(true);
      setErrorFormMsg("L'identite Auth de cet utilisateur doit etre reconciliee avant modification.");
      return;
    }
    SweetAlert.fire({
      title: `Utilisateur n° ${employeeID}`,
      text: `Voulez vous sauvegarder les changements ?`,
      icon: "warning",
      showCancelButton: true,
      reverseButtons: true,
    }).then(async (result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        if (validateForm()) {
          setLoading(true);
          setLoadingCompleted(false);
          setErrorForm(false);
          setErrorFormMsg("");

          const editUserRequest = {
            useremail: email,
            email: email,
            phone: phone,
            firstname: firstName,
            lastname: lastName,
            photo: userPhoto,
            hiredate: serializeUserDate(hireDate),
            usertype: userType,
            userstatus: userStatus,
            status: userStatus,
            salary: salary,
            bonus: bonus,
            sendpassword: sendPasswordEmail,
            terminationdate: serializeUserDate(endDate),
          };
          const operation = "user.update";
          const subjectId = String(userUID);
          const operationId = await operationTrackerRef.current.forSubmission({
            operation,
            subjectId,
            fields: editUserRequest,
          });

          try {
            await updateUserProfile(subjectId, editUserRequest, operationId);
            operationTrackerRef.current.markSucceeded();
            setLoadingCompleted(true);
            setEditMode(false);
            toast.info(
              `L'utilisateur n° ${employeeID} a été modifié avec succèss`
            );
          } catch (error) {
            console.error(error);
            setLoading(false);
            setLoadingCompleted(false);
            setErrorForm(true);
            setErrorFormMsg(error.message || "Impossible de sauvegarder l'utilisateur pour le moment.");
          }
        }

      } else if (result.isDenied) {
        return false;
      }
    });
  };

  const onDeleteSubmit = (data) => {
    if (profileUnavailable || !userUID) {
      setErrorForm(true);
      setErrorFormMsg("L'identite Auth de cet utilisateur doit etre reconciliee avant archivage.");
      return;
    }
    SweetAlert.fire({
      title: `Utilisateur n° ${employeeID}`,
      text: `Voulez vous réellement supprimer l'utilisateur ?`,
      icon: "warning",
      showCancelButton: true,
      reverseButtons: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoading(true);
        setLoadingCompleted(false);
        setErrorForm(false);
        setErrorFormMsg("");

        const subjectId = String(userUID);
        const operation = "user.delete";
        const fields = {};
        const operationId = await operationTrackerRef.current.forSubmission({
          operation,
          subjectId,
          fields,
        });

        try {
          await archiveUserProfile(subjectId, operationId);
          operationTrackerRef.current.markSucceeded();
          setLoadingCompleted(true);
          setEditMode(false);
          toast.info(
            `L'utilisateur n° ${employeeID} a été archivé avec succès`
          );
        } catch (error) {
          console.error(error);
          setLoading(false);
          setLoadingCompleted(false);
          setErrorForm(true);
          setErrorFormMsg(error.message || "Impossible de supprimer l'utilisateur pour le moment.");
        }

      } else if (result.isDenied) {
        return false;
      }
    });
  };

  const twoDecimalFormat = (event) => {
    let key = event.key || event.charCode;
    let textVal = event.target.value;

    if (event.key != "Backspace") {
      if (/^[0-9]{2}$/i.test(textVal)) {
        event.target.value = event.target.value + ".";
      }
    }
  };

  async function getUserByID(employeeID) {
    try {
      const user = await findUserByEmployeeID(employeeID, { forceRefresh: true });

      if (!user) {
        setProfileUnavailable(true);
        setErrorForm(true);
        setErrorFormMsg("Utilisateur introuvable ou archive.");
        return;
      }

      const authUid = String(user.authUid || "").trim();
      setProfileUnavailable(!authUid);
      setUserUID(authUid);
      if (!authUid) {
        setErrorForm(true);
        setErrorFormMsg("L'identite Auth de cet utilisateur doit etre reconciliee avant modification.");
      }
      setFirstName(user.firstname || "");
      setLastName(user.lastname || "");
      setHireDate(parseUserDate(user.hiredateRaw || user.hiredate) || "");
      setPhone(user.phone || "");
      setEmail(user.email || user.useremail || "");
      setSalary(user.salary || "");
      setBonus(user.bonus || "0");
      setUserStatus(user.userstatus || user.status || "Actif");
      setUserType(user.usertype || "Agent");
      setUserPhoto(user.photo || "");
      setEndDate(parseUserDate(user.terminationdateRaw || user.terminationdate) || "");
    } catch (error) {
      console.error(error);
      setErrorForm(true);
      setErrorFormMsg("Impossible de charger l'utilisateur.");
    }
  }

  return (
    <Fragment>
      {!loading ? (
        <Form className="card" onSubmit={handleSubmit(onEditSubmit)}>
          <CardHeader className="pb-0">
            <H4 attrH4={{ className: "card-title mb-0" }}>{EditUserTxt}</H4>
          </CardHeader>
          <CardBody>
            <Row>
              <Col md="8">
                <span
                  className={`error-form ${!errorForm ? "hidden" : "fadeIn"}`}
                >
                  {errorFormMsg}
                </span>
                <Row>
                  <Col md="4">
                    <div className="profile-title">
                      <H4 attrH4={{ className: "card-title m-t-20 f-16" }}>
                        Employé : {employeeID}
                      </H4>
                      <div className="media m-l-0">
                        <FsLightbox
                          openOnMount={false}
                          types={["image"]}
                          toggler={imgToggle}
                          sources={[profilePhoto]}
                        />
                        <img
                          src={profilePhoto}
                          alt="Galerie"
                          className="media paymodal-img m-l-0 img-thumbnail media"
                          onClick={(event) => {
                            imgToggle
                              ? setImgToggle(false)
                              : setImgToggle(true);
                          }}
                        />
                      </div>
                    </div>
                    <div className="form-footer">
                      <input
                        ref={photoInputRef}
                        type="file"
                        accept="image/*"
                        className="d-none"
                        onChange={handlePhotoChange}
                      />
                      <Btn
                        attrBtn={{
                          className: "btn-block m-b-20 m-t-20",
                          color: "primary",
                          disabled: !editMode,
                          type: "button",
                          onClick: handlePhotoButtonClick,
                        }}
                      >
                        {i18n.t('Dashboard_Users_ChangePhoto')}
                      </Btn>
                    </div>
                  </Col>
                  <Col md="8">
                    <Row>
                      <Col xs="6" sm="6" md="6">
                        <FormGroup className="mb-3">
                          <Label className="form-label">{firstnameTxt}</Label>
                          <Input
                            className="form-control"
                            type="text"
                            disabled={editMode ? false : true}
                            placeholder={firstnameTxt}
                            value={firstName}
                            onChange={(e) => setFirstName(e.target.value)}
                          />
                          <span
                            className={`error-form ${
                              !errorFirstName ? "hidden" : "fadeIn"
                            }`}
                          >
                            {errorFieldMsg}
                          </span>
                        </FormGroup>
                      </Col>
                      <Col xs="6" sm="6" md="6">
                        <FormGroup className="mb-3">
                          <Label className="form-label">{lastnameTxt}</Label>
                          <Input
                            className="form-control"
                            type="text"
                            disabled={editMode ? false : true}
                            placeholder={lastnameTxt}
                            value={lastName}
                            onChange={(e) => setLastName(e.target.value)}
                          />
                          <span
                            className={`error-form ${
                              !errorLastName ? "hidden" : "fadeIn"
                            }`}
                          >
                            {errorFieldMsg}
                          </span>
                        </FormGroup>
                      </Col>
                      <Col xs="6" sm="6" md="6">
                        <FormGroup className="mb-3">
                          <Label className="form-label">{phoneTxt}</Label>
                          <Input
                            className="form-control"
                            type="text"
                            disabled={editMode ? false : true}
                            placeholder={phoneTxt}
                            value={phone}
                            onChange={(e) => setPhone(e.target.value)}
                          />
                          <span
                            className={`error-form ${
                              !errorPhone ? "hidden" : "fadeIn"
                            }`}
                          >
                            {errorFieldMsg}
                          </span>
                        </FormGroup>
                      </Col>
                      <Col xs="6" sm="6" md="6">
                        <FormGroup className="mb-3">
                          <Label className="form-label">{emailTxt}</Label>
                          <Input
                            className="form-control"
                            type="text"
                            disabled={editMode ? false : true}
                            placeholder={emailTxt}
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                          />
                          <span
                            className={`error-form ${
                              !errorEmail ? "hidden" : "fadeIn"
                            }`}
                          >
                            {errorEmailMsg}
                          </span>
                        </FormGroup>
                      </Col>
                      <Col xs="6" sm="6" md="6">
                        <FormGroup className="mb-3">
                          <Label className="form-label">{hireDateTxt}</Label>
                          <div className="daterange-card">
                            <div className="theme-form">
                              <FormGroup>
                                <DatePicker
                                  className="form-control digits"
                                  onChange={(updateDate) =>
                                    setHireDate(updateDate)
                                  }
                                  startDate={hireDate}
                                  selected={hireDate}
                                  calendarStartDay={1}
                                  dropdownMode="select"
                                  dateFormat="yyyy-MM-dd"
                                  todayButton={i18n.t('Dashboard_LatestActivity_Today')}
                                  placeholderText={hireDateTxt}
                                  disabled={editMode ? false : true}
                                />
                              </FormGroup>
                            </div>
                          </div>
                          <span
                            className={`error-form ${
                              !errorHireDate ? "hidden" : "fadeIn"
                            }`}
                          >
                            {errorFieldMsg}
                          </span>
                        </FormGroup>
                      </Col>
                      <Col xs="6" sm="6" md="6">
                        <FormGroup className="mb-3">
                          <Label className="form-label">{salaryTxt}</Label>
                          <Input
                            className="form-control"
                            type="text"
                            disabled={editMode ? false : true}
                            placeholder={salaryTxt}
                            value={salary}
                            onChange={(e) => setSalary(e.target.value)}
                            onKeyDown={(event) => twoDecimalFormat(event)}
                            onKeyPress={(event) => {
                              if (errorSalary) {
                                setErrorSalary(false);
                              }

                              if (!/^[0-9.\x08]+$/.test(event.key)) {
                                event.preventDefault();
                                setErrorSalaryMsg(
                                  "Veuillez entrer des numéros seulement"
                                );
                                setErrorSalary(true);
                              }

                              if (event.target.value.length > 4) {
                                event.target.value = event.target.value.substr(
                                  0,
                                  4
                                );
                              }
                            }}
                          />
                          <span
                            className={`error-form ${
                              !errorSalary ? "hidden" : "fadeIn"
                            }`}
                          >
                            {errorSalaryMsg}
                          </span>
                        </FormGroup>
                      </Col>
                      <Col xs="6" sm="6" md="6">
                        <FormGroup className="mb-3">
                          <Label className="form-label">{bonusTxt}</Label>
                          <Input
                            className="form-control"
                            type="text"
                            disabled={editMode ? false : true}
                            placeholder={bonusTxt}
                            value={bonus}
                            onChange={(e) => setBonus(e.target.value)}
                          />
                        </FormGroup>
                      </Col>
                      <Col xs="6" sm="6" md="6">
                        <FormGroup>
                          <Label className="form-label">{userTypeTxt}</Label>
                          <Input
                            type="select"
                            name="select"
                            disabled={editMode ? false : true}
                            className="form-control btn-square"
                            value={userType}
                            onChange={(e) => setUserType(e.target.value)}
                          >
                            {userTypeMapping.map((items, i) => (
                              <option key={i} value={items}>
                                {items}
                              </option>
                            ))}
                            ;
                          </Input>
                          <span
                            className={`error-form ${
                              !errorUserType ? "hidden" : "fadeIn"
                            }`}
                          >
                            {errorFieldMsg}
                          </span>
                        </FormGroup>
                      </Col>
                      <Col xs="6" sm="6" md="6">
                        <FormGroup>
                          <Label className="form-label">{i18n.t('Dashboard_Users_Status')}</Label>
                          <Input
                            type="select"
                            name="select"
                            disabled={editMode ? false : true}
                            className="form-control btn-square"
                            value={userStatus}
                            onChange={(e) => setUserStatus(e.target.value)}
                          >
                            {StatusMapping.map((items, i) => (
                              <option key={i} value={items}>
                                {items}
                              </option>
                            ))}
                            ;
                          </Input>
                        </FormGroup>
                      </Col>
                      {isTerminatedStatus(userStatus) ? (
                        <Col xs="6" sm="6" md="6">
                          <FormGroup className="mb-3">
                            <Label className="form-label">
                              {terminationDateTxt}
                            </Label>
                            <DatePicker
                              className="form-control digits"
                              startDate={endDate}
                              selected={endDate}
                              calendarStartDay={1}
                              onChange={(date) => setEndDate(date)}
                              dropdownMode="select"
                              dateFormat="yyyy-MM-dd"
                              todayButton={i18n.t('Dashboard_LatestActivity_Today')}
                              placeholderText={terminationDateTxt}
                              minDate={new Date(hireDate)}
                            />
                            <span
                              className={`error-form ${
                                !errorEndDate ? "hidden" : "fadeIn"
                              }`}
                            >
                              {errorFieldMsg}
                            </span>
                          </FormGroup>
                        </Col>
                      ) : (
                        ""
                      )}
                    </Row>
                    <Col xs="12" sm="12" md="12">
                      <FormGroup className="mb-3">
                        <div className="checkbox checkbox-solid-primary">
                          <Input
                            id="solid3"
                            type="checkbox"
                            checked={sendPasswordEmail}
                            onChange={(e) =>
                              setSendPasswordEmail(e.target.checked)
                            }
                          />
                          <Label for="solid3">{sendEmailTxt}</Label>
                        </div>
                      </FormGroup>
                    </Col>
                  </Col>
                </Row>
              </Col>
            </Row>
          </CardBody>
          <CardFooter className="text-end">
            <button
              type="button"
              class="btn btn-secondary btn-block pull-left"
              disabled={profileUnavailable}
              onClick={(e) => setEditMode(!editMode)}
            >
              {!editMode ? i18n.t('Dashboard_Common_Edit') : i18n.t('Dashboard_Common_Cancel')}{" "}
            </button>
            {!editMode ? (
              ""
            ) : (
              <button
                type="button"
                className="btn btn-danger m-l-20 btn-block pull-left"
                disabled={profileUnavailable}
                onClick={onDeleteSubmit}
              >
                {DeleteTxt}
              </button>
            )}
            <Btn attrBtn={{ color: "primary", type: "submit", disabled: !editMode || profileUnavailable }}>{Save}</Btn>
          </CardFooter>
        </Form>
      ) : (
        <Card>
          <CardBody>
            <Card className="no-border">
              <Row>
                <Col md="12">
                  <p class="p-t-30 text-center text-bold">
                    {i18n.t('Dashboard_Users_StayOnPage')} <br />
                  </p>
                  <p class="p-t-0 text-center">
                    {i18n.t('Dashboard_Users_UpdatingUser')} : {employeeID}{" "}
                  </p>

                  <div className={`loader-box loading-paymodal`}>
                    {!loadingCompleted ? (
                      <div class="loader-container paymodal-loading-container m-t-40 m-b-40">
                        <div class="loader-box paymodal-loader-box">
                          <div class="paycard-loader"></div>
                        </div>
                      </div>
                    ) : (
                      <div class="loader-container paymodal-loading-container  m-b-40">
                        <i className="fa fa-check-circle f-80 m-t-30 f-color-primary"></i>
                      </div>
                    )}

                    {!loadingCompleted ? (
                      <h3 class="loading-message f-color-primary f-20 m-t-40">
                        {i18n.t('Dashboard_Users_PleaseWait')}
                      </h3>
                    ) : (
                      <h3 class="loading-message f-color-primary f-20 m-t-40">
                        {i18n.t('Dashboard_Users_Success')}
                      </h3>
                    )}

                    {!loadingCompleted ? (
                      <p class="p-t-0 text-center">
                        {i18n.t('Dashboard_Users_Redirecting')}
                      </p>
                    ) : (
                      <Link
                        to={`${process.env.PUBLIC_URL}/dashboard/users`}
                        className="btn btn-secondary btn-block m-t-40 p-t-15 p-b-15"
                      >
                        {i18n.t('Dashboard_Users_ViewList')}
                      </Link>
                    )}
                  </div>
                </Col>
              </Row>
            </Card>
          </CardBody>
        </Card>
      )}
    </Fragment>
  );
};
export default EditUser;
